export default "__VITE_ASSET__wThj1z4V__"